import React , {useState , useEffect} from "react";
import { Navigation } from '../components/navigation'
import { Header } from '../components/header'
import { Features } from '../components/features'
import { About } from '../components/about'
import { Team } from '../components/Team'
import { Contact } from '../components/contact'
import SmoothScroll from "smooth-scroll";
import JsonData from "../data/data.json";
export const scroll = new SmoothScroll('a[href*="#"]', {
    speed: 1000,
    speedAsDuration: true,
  });
const Home = () => {
    const [landingPageData, setLandingPageData] = useState({});
    useEffect(() => {
      setLandingPageData(JsonData);
    }, []);{
    
    
    
  return (
    <div>
      
      <Navigation/>
    <Header data={landingPageData.Header} />
    <Features data={landingPageData.Features} />
    <About data={landingPageData.About} />
    <Team data={landingPageData.Team} />
    <Contact data={landingPageData.Contact} /> 
   
    </div>
  )
}
}
export default Home